// import Vue from 'vue';
import Utility from "../../js/utility";
import BaseModule from '../_base_module';

// initial state
// shape: [{ id, quantity }]
const state = {
    ...BaseModule.state,
};

// getters
const getters = {
    ...BaseModule.getters,
    // dummy_getter(state, getters, rootState, rootGetters) {
    //
    // }
    training_sessions_reversed(state, getters, rootState, rootGetters) {
        return (user_id) => {
            return state.data.filter(training_session => training_session.user_id === user_id).sort((a, b) => b.id - a.id)
        };
    },
};

// actions
const actions = {
    ...BaseModule.actions,
    add_to_store({state, commit, dispatch, getters, rootState}, training_session) {
        commit('add_to_data', {data: training_session, push: false});

        let new_training_session = Utility.deep_clone(training_session);

        dispatch('activities/add_to_store_bulk', Utility.deep_clone(new_training_session.activities), {root: true});
    },
    /**
     * Stores a new TrainingSession
     * @returns {Promise<any> | Thenable<any> | PromiseLike<any> | *}
     */
    store({state, commit, dispatch, getters, rootState}, payload) {
        return dispatch('api/postEndpoint', {
            endpoint: '/users/' + payload.user_id + '/training-sessions',
            data: payload,
        }, {root: true}).then((response) => {
            dispatch('add_to_store', response.data.data);
            return response.data.data;
        });
    },
    /**
     * Updates an existing TrainingSession
     * @returns {Promise<any> | Thenable<any> | PromiseLike<any> | *}
     */
    update({state, commit, dispatch, getters, rootState}, payload) {
        // let training_session = getters.find(payload.training_session_id);
        // Object.keys(payload.data).forEach(property => {
        //     training_session[property] = payload.data.property;
        // })
        return dispatch('api/postEndpoint', {
            endpoint: '/users/' + payload.user_id + '/training-sessions/' + payload.training_session_id,
            data: payload,
        }, {root: true}).then((response) => {
            let training_session = response.data.data;
            dispatch('add_to_store', training_session);
        });
    },
    /**
     * Copies an existing TrainingSession
     * @returns {Promise<any> | Thenable<any> | PromiseLike<any> | *}
     */
    copy({state, commit, dispatch, getters, rootState}, payload) {
        return dispatch('api/postEndpoint', {
            endpoint: '/users/' + payload.user_id + '/training-sessions/' + payload.training_session_id + '/copy',
            data: payload,
        }, {root: true}).then((response) => {
            let training_session = response.data.data;
            dispatch('add_to_store', training_session);
        });
    },
    /**
     * Destroys an existing TrainingSession
     * @returns {Promise<any> | Thenable<any> | PromiseLike<any> | *}
     */
    destroy({state, commit, dispatch, getters, rootState}, payload) {
        return dispatch('api/deleteEndpoint', {
            endpoint: '/users/' + payload.user_id + '/training-sessions/' + payload.training_session_id,
            data: payload,
        }, {root: true}).then((response) => {
            commit('remove_from_data', {id: payload.training_session_id});
        });
    }
};

// mutations
const mutations = {
    ...BaseModule.mutations,
    // dummy_mutation (state, id) {
    //     state.id = id;
    // },
};

export default {

    namespaced: true,

    state,
    getters,
    actions,
    mutations
}
